import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import AutoComplete from '../Common/AutoComplete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleTrainerStore from '../../stores/ModuleTrainerStore';
import UserActions from '../../actions/UserActionCreator';
import TrainerStore from '../../stores/TrainerStore';

const userListItem = (user) => {
    const name = `${user.firstName} ${user.lastName}`;
    return {
        key:    user.userId,
        text:   name,
        value:  <MenuItem key={user.userId} value={user.userId} primaryText={name} />,
        user
    };
};

class EventTrainersDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onTrainerChange = this.onTrainerChange.bind(this);
        this.trainerListener = !!this.state.draft.moduleId ? ModuleTrainerStore.addListener(this.onTrainerChange) : TrainerStore.addListener(this.onTrainerChange);
    }

    componentWillUnmount() {
        this.trainerListener.remove();
    }

    render() {
        const dialogProps = {
            title:          this.props.title,
            open:           true,
            modal:          false,
            onRequestClose: this.props.onClose,
            actions: [
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="submit" label="Submit" onTouchTap={this.onSave} disabled={!this.state.draft.userId} />
            ]
        };

        const users = this.state.users.map(userListItem);

        return (
            <Dialog {...dialogProps} >
                <AutoComplete
                    floatingLabelText="Trainer *"
                    maxSearchResults={5}
                    dataSource={users}
                    onUpdateInput={this.onUserAutocomplete.bind(this)}
                    onNewRequest={this.onUserSelect.bind(this)}
                    isFetching={this.state.users.isFetching}
                />
            </Dialog>
        );
    }


    onUserAutocomplete(input) {
        if (input !== undefined && input.length >= 3) {
            if (!!this.state.draft.moduleId) {
                ModuleActions.getTrainers(this.state.draft.moduleId);
            } else {
                UserActions.getTrainers();
            }
        }
    }

    onUserSelect({user}) {
        if (!!user && user.userId !== this.state.draft.userId) {
            DialogActions.bulkUpdateDraft({id: Date.now(), userId: user.userId, title: user.title, firstName: user.firstName, lastName: user.lastName, role: 'trainer'});
        }
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }

    onTrainerChange() {
        const users = !!this.state.draft.moduleId ? ModuleTrainerStore.getByModule(this.state.draft.moduleId) : TrainerStore.getAll();
        if (!!users) {
            this.setState({users});
        }
    }
}

EventTrainersDialog.getStores = () => ([DialogStore]);
EventTrainersDialog.calculateState = (prevState) => {
    const {open, draft} = DialogStore.getState();
    return {
        open,
        draft,
        users: []
    };
};
EventTrainersDialog.propTypes = {
    title:          PropTypes.string,
    moduleId:       PropTypes.number,
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

EventTrainersDialog.defaultProps = {
    title:          'Add Trainer',
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(EventTrainersDialog);
